import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

const SearchComponent = ({ className, placeHolder, onChange,onPressEnter,style }) => {
   return (
      <Input
         className={`rounded rounded-4  ${className ? className : ""}`}
         placeholder={placeHolder}
         prefix={<SearchOutlined />}
         allowClear
         onChange={onChange}
         style={style}
         onPressEnter={onPressEnter}
      />
   );
};

export default SearchComponent;
